const sizeTypes = [
  {
    label: 'Médio',
    value: 'medium',
  },
  {
    label: 'Normal',
    value: 'default',
  },
  {
    label: 'Icone',
    value: 'icon',
  },
  {
    label: 'Pequeno',
    value: 'small',
  },
];

export default sizeTypes;
